import {missionApi} from '../api/missionApi';
import {
    AdminMissionDto,
    AdminMissionTierDto,
    MissionRewardCostumeDto,
    PatchMissionRequest,
    PatchMissionTierRequest,
} from '../types/mission';
import {
    useBaseMutation,
    useBaseQuery,
    useInvalidateQueries,
} from './useBaseQuery';

// ── Query Key Factory ────────────────────────────────────────────────────────

export const missionKeys = {
    all: ['missions'] as const,
    lists: () => [...missionKeys.all, 'list'] as const,
    list: () => [...missionKeys.lists()] as const,
    rewardCostumes: () => [...missionKeys.all, 'rewardCostumes'] as const,
};

// ── Queries ──────────────────────────────────────────────────────────────────

export const useMissions = () => {
    return useBaseQuery<AdminMissionDto[]>(missionKeys.list(), () =>
        missionApi.getAll()
    );
};

export const useRewardCostumes = () => {
    return useBaseQuery<MissionRewardCostumeDto[]>(
        missionKeys.rewardCostumes(),
        () => missionApi.getRewardCostumes(),
        {staleTime: 5 * 60 * 1000}
    );
};

// ── Mutations ────────────────────────────────────────────────────────────────

export interface PatchMissionVars {
    id: number;
    body: PatchMissionRequest;
}

export const usePatchMission = () => {
    const {invalidate} = useInvalidateQueries();
    return useBaseMutation<PatchMissionVars, AdminMissionDto>(
        ({id, body}) => missionApi.patchMission(id, body),
        {
            onSuccess: () => {
                invalidate(missionKeys.list());
            },
        }
    );
};

export interface PatchTierVars {
    tierId: number;
    body: PatchMissionTierRequest;
}

export const usePatchMissionTier = () => {
    const {invalidate} = useInvalidateQueries();
    return useBaseMutation<PatchTierVars, AdminMissionTierDto>(
        ({tierId, body}) => missionApi.patchTier(tierId, body),
        {
            onSuccess: () => {
                invalidate(missionKeys.list());
            },
        }
    );
};
